/**
 * Namen für Protokolle und Dienste im Datenverkehr. Die Nummern stammen aus
 * den IANA-Registern „Protocol Numbers“ und „Service Name and Transport
 * Protocol Port Number“; hier stehen nur die, die in Kundennetzen täglich
 * vorkommen. Unbekannte zeigen die Nummer.
 */
const PROTOKOLLE: Record<number, string> = {
  1: 'ICMP',
  6: 'TCP',
  17: 'UDP',
  47: 'GRE',
  50: 'ESP',
  58: 'ICMPv6',
}

const DIENSTE: Record<string, string> = {
  'tcp/20': 'FTP-Daten',
  'tcp/21': 'FTP',
  'tcp/22': 'SSH',
  'tcp/23': 'Telnet',
  'tcp/25': 'SMTP',
  'udp/53': 'DNS',
  'tcp/53': 'DNS',
  'udp/67': 'DHCP',
  'udp/68': 'DHCP',
  'tcp/80': 'HTTP',
  'udp/123': 'NTP',
  'tcp/110': 'POP3',
  'tcp/143': 'IMAP',
  'udp/161': 'SNMP',
  'udp/162': 'SNMP-Trap',
  'tcp/389': 'LDAP',
  'tcp/443': 'HTTPS',
  'udp/443': 'QUIC',
  'tcp/445': 'SMB',
  'udp/500': 'IPsec IKE',
  'udp/514': 'Syslog',
  'tcp/587': 'SMTP-Submission',
  'tcp/636': 'LDAPS',
  'tcp/993': 'IMAPS',
  'tcp/995': 'POP3S',
  'udp/1194': 'OpenVPN',
  'tcp/1433': 'MS SQL',
  'udp/1900': 'SSDP',
  'udp/2055': 'NetFlow',
  'tcp/3306': 'MySQL',
  'tcp/3389': 'RDP',
  'udp/3389': 'RDP',
  'udp/4500': 'IPsec NAT-T',
  'udp/5060': 'SIP',
  'tcp/5060': 'SIP',
  'udp/5353': 'mDNS',
  'tcp/5432': 'PostgreSQL',
  'udp/6343': 'sFlow',
  'tcp/8006': 'Proxmox',
  'tcp/8080': 'HTTP-Alternativ',
  'tcp/8291': 'Winbox',
  'tcp/8443': 'HTTPS-Alternativ',
  'udp/51820': 'WireGuard',
}

export function protokollName(proto: number | undefined): string {
  const p = proto ?? 0
  return PROTOKOLLE[p] ?? `Protokoll ${p}`
}

/** „HTTPS (tcp/443)“ oder nur „tcp/8123“, wenn der Dienst keinen Namen hat. */
export function dienstName(proto: number | undefined, port: number | undefined): string {
  const p = proto ?? 0
  if (p !== 6 && p !== 17) return protokollName(p)
  const key = `${p === 6 ? 'tcp' : 'udp'}/${port ?? 0}`
  const name = DIENSTE[key]
  return name ? `${name} (${key})` : key
}
